import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DateTime } from 'luxon';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import FormDetails from 'app/components/form/FormDetails';

import useApi from 'app/context/useApi';
import useApp from 'app/context/useApp';

const useStyles = makeStyles(theme => ({
    saveButtonContainer: {
        padding: theme.spacing(3)
    },
    saveButton: {
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(5),
    },
}));

export default function FormSettings(props) {

    const { loading, setLoading, getForm, groups } = props;

    const classes = useStyles();
    const api = useApi();
    const { app } = useApp();

    const [ form, setForm ] = useState(props.form);
    const [ status, setStatus ] = useState('inactive');
    const [ errors, setErrors ] = useState({});

    const formId = props.form.id;

    const initTime = DateTime.local().setZone(app.club.timezone).plus({days: 1}).startOf('hour');

    // handlers ------------------------------------------------

    const handleForm = name => action => {

        let value;

        if (DateTime.isDateTime(action) || action === null) {
            value = action;
        } else {
            const target = action.target;
            value = (target.type === 'checkbox' ? target.checked : target.value);
        }

        if (isError(name)) delete errors[name];

        setForm({ ...form, [name]: value });
    };

    useEffect(() => {

        if (props.form.starts_at !== null) setStatus('scheduled');
        else if (props.form.active === true) setStatus('active');
        else setStatus('inactive');

    }, [props.form])

    const handleStatus = e => {

        const newStatus = e.target.value;
        const newForm = { ...form };

        switch (newStatus) {
            case 'inactive':
                newForm.active = false;
                newForm.starts_at = null;
                newForm.ends_at = null;
                newForm.global = false;
                break;
            case 'active':
                newForm.active = true;
                newForm.starts_at = null;
                newForm.ends_at = null;
                break;
            case 'scheduled':
                newForm.active = false;

                if (status !== 'scheduled' && form.starts_at === null && form.ends_at === null) {
                    newForm.starts_at = initTime;
                    newForm.ends_at = initTime.plus({ days: 7 });
                }

                break;
        }

        setStatus(newStatus);
        setForm(newForm);
    }

    // Post Function ------------------------------------------

    const postForm = () => {

        setLoading(true)

        const data = {...form, ...props.form.fields}

        if (form.starts_at) data.starts_at = form.starts_at.toSeconds();
        if (form.ends_at) data.ends_at = form.ends_at.toSeconds();

        api.post(`/admin/form/${formId}`, data)
            .then(() => getForm())
            .catch(error => {
                if (error?.response?.data?.errors) {
                    setErrors(error.response.data.errors)
                    setLoading(false)
                }
            });
    }

    // Errors ---------------------------------------------------

    const isError = field => {
        if (errors[field]) return true;
        return false;
    }

    const getErrorMessage = field => {
        if (isError(field)) return errors[field];
        return "";
    }

    return (
        <>
            <FormDetails
                form={form}
                status={status}
                groups={groups}
                handleForm={handleForm}
                handleStatus={handleStatus}
                errors={errors}
                isError={isError}
                getErrorMessage={getErrorMessage}
            />
            <Typography align="right" component="div" className={classes.saveButtonContainer}>
                <Button
                    disabled={loading}
                    variant="contained"
                    color="primary"
                    onClick={postForm}
                    className={classes.saveButton}
                    size="small"
                    >
                    save
                </Button>
            </Typography>
        </>
    );
}
